Analytics  = {
    dimension1Msg: "",
    gameKey: "f09de8157273be100fa530c93b5c4b7f",
    gameSecretKey: "7a5417f4a022657dda8b9f076b6b9e822b960b29",
    azGameKey: _azGameKey,
    azSecretKey: _azSecretKey,
    azGoogleId: _azGoogleId,
    azGameName: _azGameName,
    azTagId: _azTagId,
    azTagPublisher: _azTagPublisher,
    azTagGameName: _azTagGameName,

    trackEvent: function(t) {
        console.log(t);
        sdkHandler.trigger('gameTracking', {
            event: 'Design',
            dimension1: t
        }, this)
    }
}

TrackingEvent = {
    firstGameLoaded: "First Game loaded",

    firstLevelStarted: "First level started",
    firstLevelFinished: "First level completed",

    secondLevelStarted: "Second level started",
    secondLevelFinished: "Second level completed",
    
    thirdLevelStarted: "Third level started",
    thirdLevelFinished: "Third level completed",

    fourthLevelStarted: "Fourth level started",
    fourthLevelFinished: "Fourth level completed",

    fifthLevelStarted: "Fifth level started",
    fifthLevelFinished: "Fifth level finished",

    sixthLevelStarted: "Sixth level started",
    sixthLevelFinished: "Sixth level completed",

    seventhLevelStarted: "Seventh level started",
    seventhLevelFinished: "Seventh level completed",

    eigthLevelStarted: "Eighth  level started",
    eigthLevelFinished: "Eighth  level completed",

    ninthLevelStarted: "Ninth level started",
    ninthLevelFinished: "Ninth level completed",

    tenthLevelStarted: "Tenth level started",
    tenthLevelFinished: "Tenth level completed"
}
